import { PayloadAction } from '@reduxjs/toolkit';

import { SidebarState } from 'editor/src/store/editorModules/sidebar/types';

const setDynamicTabsReducer = (state: SidebarState, action: PayloadAction<SidebarState['dynamicTabs']>) => {
  state.dynamicTabs = action.payload;
};

export default setDynamicTabsReducer;
